import React, { useState, useEffect, Fragment } from 'react';
import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import EastIcon from "@mui/icons-material/East";
import LoadingButton from '@mui/lab/LoadingButton';
import { FormControl, MenuItem, InputLabel, Select } from "@mui/material";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import moment from 'moment';
import { getCarbrand, getCarmodel } from '../APImaster';    // getProvince, getAmphur, 

import { useForm } from "react-hook-form";

export default function DefaultForm({ onSave, handleBack, initalData, dataStep1, dataStep2, dataStep3, dataStep4, dataStep5 }) {
    const [gender, setGender] = useState("");
    // const [birthday, setBirthday] = useState("");
    // const [is_punish, setIs_punish] = useState("1");
    // const [education_qual, setEducation_qual] = useState('');
    // const [educationList, setEducationList] = useState([
    //     "ต่ำกว่ามัธยมศึกษาตอนปลาย / ปวช.",
    //     "มัธยมศึกษาตอนปลาย / ปวช.",
    //     "อนุปริญญา / ปวส.",
    //     "ปริญญาตรี",
    //     "ปริญญาโท หรือสูงกว่า"
    // ]);
    const [step1Data, setStep1Data] = useState(null);
    const [step2Data, setStep2Data] = useState(null);
    const [step3Data, setStep3Data] = useState(null);
    const [step4Data, setStep4Data] = useState(null);
    const [step5Data, setStep5Data] = useState(null);
    const [buttonSubmitDisable, setButtonSubmitDisable] = useState(true);

    const [carbrand, setCarbrand] = useState("");
    const [carbrandList, setCarbrandList] = useState([]);
    const [carmodel, setCarmodel] = useState("");
    const [carmodelList, setCarmodelList] = useState([]);
    const [carmodelFullList, setCarmodelFullList] = useState([]);

    const { register, formState: { errors }, handleSubmit } = useForm({});
    // const { register, formState: { errors }, handleSubmit, setValue, reset } = useForm({});
    // const [user, setUser] = useState(null);

    useEffect(() => {

        // get Carbrand
            var MTcarbrand = JSON.parse(localStorage.getItem('carbrand'));
            if(MTcarbrand){
                // console.log("MT carbrand if");
                setCarbrandList(MTcarbrand);
            }else{
                // console.log("MT carbrand else");
                getCarbrand().then(response => {
                    if (response && response.status === 200) {
                        // localStorage.removeItem("masterdata"); 
                        var a = JSON.stringify(response.data);
                        var b = JSON.parse(a);
                        // console.log("mad test", b );
                        // localStorage.setItem("masterdata", a); 
                        localStorage.setItem("carbrand", a);

                        setCarbrandList(response.data);
                    }
                })
            }

        // get Carmodel
            var MTcarmodel = JSON.parse(localStorage.getItem('carmodel'));
            if(MTcarmodel){
                // console.log("MT carmodel if");
                setCarmodelFullList(MTcarmodel);
            }else{
                // console.log("MT carmodel else");
                getCarmodel().then(response => {
                    if (response && response.status === 200) {
                        // localStorage.removeItem("masterdata"); 
                        var a = JSON.stringify(response.data);
                        var b = JSON.parse(a);
                        // console.log("mad test", b );
                        // localStorage.setItem("masterdata", a); 
                        localStorage.setItem("carmodel", a);

                        setCarmodelFullList(response.data);
                    }
                })
            }


        getData();
    }, []);

    // useEffect(() => {
    //     // reset form with user data
    //     reset(user);
    // }, [user]);

    const onSubmit = (data) => {
      // console.log("onsubmit",data);
        onSave(data);
    };

    function getData() {
        // console.log("tab6 getData dataStep1", dataStep1);
        if (dataStep1 !== "") {
            setStep1Data({
                plate_no: dataStep1.plate_no,
                ref_no: dataStep1.ref_no,
                customer_name: dataStep1.customer_name,
                // customer_lastname: dataStep1.customer_lastname,
                car_brand: dataStep1.car_brand,
                car_model: dataStep1.car_model,
                car_brand_desc: dataStep1.car_brand_desc,
                car_model_desc: dataStep1.car_model_desc,
                mileage: dataStep1.mileage,
                // imageSrc: dataStep1.imageSrc,
                capturedImages: dataStep1.capturedImages,
            })
                setCarbrand(dataStep1.car_brand);
                    setCarmodel(dataStep1.car_model);
        }
        if (dataStep2 !== "") {
            // console.log("dataStep2", dataStep2);
            // setCapturedImages(dataStep2.capturedImages);
            setStep2Data({
                capturedImages: dataStep2.capturedImages,
            })
        }
        if (dataStep3 !== "") {
            console.log("dataStep3", dataStep3);
            setStep3Data({
                capturedImages: dataStep3.capturedImages,
                capturedTextImages: dataStep3.capturedTextImages,
                imagesAudioEquipment: dataStep3.imagesAudioEquipment && dataStep3.imagesAudioEquipment.length > 0 ?
                                        [dataStep3.imagesAudioEquipment[0]] : null,
                imagesSpareTire: dataStep3.imagesSpareTire && dataStep3.imagesSpareTire.length > 0 ?
                                        [dataStep3.imagesSpareTire[0]] : null,
                imagesCarCAM: dataStep3.imagesCarCAM && dataStep3.imagesCarCAM.length > 0 ?
                                        [dataStep3.imagesCarCAM[0]] : null,
                // imagesMaxWheel: dataStep3.imagesMaxWheel && dataStep3.imagesMaxWheel.length > 0 ?
                //                         [dataStep3.imagesMaxWheel[0]] : null,
                imagesMaxWheel: dataStep3.has_maxWheel ? dataStep3.has_maxWheel : 0,
            })
        }
        if (dataStep4 !== "") {
            // console.log("dataStep4", dataStep4);
            setStep4Data({
                capturedImages: dataStep4.capturedImages,
                capturedTextImages: dataStep4.capturedTextImages,
                imagesCarBook: dataStep4.imagesCarBook && dataStep4.imagesCarBook.length > 0 ?
                                        [dataStep4.imagesCarBook[0]] : null,
                imagesCarTax: dataStep4.imagesCarTax && dataStep4.imagesCarTax.length > 0 ?
                                        [dataStep4.imagesCarTax[0]] : null,
                imagesCarChassis: dataStep4.imagesCarChassis && dataStep4.imagesCarChassis.length > 0 ?
                                        [dataStep4.imagesCarChassis[0]] : null,
                imagesCarLicense: dataStep4.imagesCarLicense && dataStep4.imagesCarLicense.length > 0 ?
                                        [dataStep4.imagesCarLicense[0]] : null,
            })
        }
        if (dataStep5 !== "") {
            // console.log("dataStep5", dataStep5);
            setStep5Data({
                has_damaged: dataStep5.has_damaged,
                capturedImages: dataStep5.capturedImages,
                damage_detail: dataStep5.damage_detail,
            })
        }


    }

    function acceptionClick(){
        console.log("acceptionClick", buttonSubmitDisable);
        // if(buttonSubmitDisable){
            setButtonSubmitDisable(!buttonSubmitDisable);
        // }
    }

    return (
        <React.Fragment>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3}>
                {/*<Grid container spacing={3} style={{display:"none"}}>*/}
                    <Grid item xs={12} sm={12}><h4>ข้อมูลรถ</h4></Grid>
                    <Grid item xs={3} sm={3}>
                        <FormLabel >ทะเบียนรถ</FormLabel>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <FormLabel >{dataStep1?.plate_no?dataStep1.plate_no:"-"}</FormLabel>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <FormLabel >จังหวัด</FormLabel>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        {/*<FormLabel >{dataStep1?.plate_provinceID?dataStep1.plate_provinceID:"-"}</FormLabel>*/}
                        <FormLabel >{initalData?.plate_province_desc?initalData.plate_province_desc:"-"}</FormLabel>
                    </Grid>

                    <Grid item xs={3} sm={3}>
                        <FormLabel >ยี่ห้อรถ</FormLabel>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <FormLabel >{dataStep1?.car_brand_desc?dataStep1.car_brand_desc:"-"}</FormLabel>
                    </Grid>

                    {/*<Grid item xs={12} sm={6}>
                        <FormControl fullWidth={true}>
                            <TextField
                                {...register("car_brand")}
                                id="car_brand"
                                select
                                label="ยี่ห้อ"
                                value={carbrand}
                                InputLabelProps={{ sx: { zIndex: 'auto' } }}
                                onChange={(event) => {
                                    console.log("OnChangeCarbrand event", event);
                                    // setCarbrand(event.target.value)
                                    // setCarmodel('');
                                    // setCarmodelDesc('');
                                    // // getAmphur(event.target.value)
                                    // OnChangeCarbrand(event.target.value)
                                }}
                            >
                                {carbrandList.map(item =>
                                    <MenuItem value={item.cbrandID} key={item.cbrandID}>{item.cbrand_name_en}</MenuItem>
                                )}
                            </TextField>
                        </FormControl>
                    </Grid>*/}

                    <Grid item xs={3} sm={3}>
                        <FormLabel >รุ่นรถ</FormLabel>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <FormLabel >{dataStep1?.car_model_desc?dataStep1.car_model_desc:"-"}</FormLabel>
                    </Grid>

                    <Grid item xs={3} sm={3}>
                        <FormLabel >สี</FormLabel>
                    </Grid>
                    <Grid item xs={3} sm={9}>
                        {/*<FormLabel >{dataStep1?.car_color?dataStep1.car_color:"-"}</FormLabel>*/}
                        <FormLabel >{initalData?.car_color?initalData.car_color:"-"}</FormLabel>
                    </Grid>

                    <Grid item xs={3} sm={3}>
                        <FormLabel >เลขตัวถัง</FormLabel>
                    </Grid>
                    <Grid item xs={3} sm={9}>
                        {/*<FormLabel >{dataStep1?.chassis_no?dataStep1.chassis_no:"-"}</FormLabel>*/}
                        <FormLabel >{initalData?.chassis_no?initalData.chassis_no:"-"}</FormLabel>
                    </Grid>

                    <Grid item xs={3} sm={3}>
                        <FormLabel >เลขเครื่องยนต์</FormLabel>
                    </Grid>
                    <Grid item xs={3} sm={9}>
                        {/*<FormLabel >{dataStep1?.engine_no?dataStep1.engine_no:"-"}</FormLabel>*/}
                        <FormLabel >{initalData?.engine_no?initalData.engine_no:"-"}</FormLabel>
                    </Grid>
                    

                    <Grid item xs={12} sm={12}><h4>รายละเอียดความเสียหาย</h4></Grid>
                        {
                            dataStep5?.damage_detail?
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    // {...register("damage_detail")}
                                    // aria-invalid={errors.damage_detail ? "true" : "false"}
                                    fullWidth
                                    // id="damage_detail"
                                    // label=""
                                    multiline
                                    minRows={4}
                                    maxRows={4} // over max rows has scrollbar
                                    InputLabelProps={{ shrink: true }}
                                    // onChange={handleDamageDetailChange}
                                    // disabled
                                    value={(dataStep5?.damage_detail?dataStep5.damage_detail:"")}
                                />
                            </Grid>
                            : <>
                            <Grid item xs={4} sm={4}></Grid>
                            <Grid item xs={4} sm={4}>
                                <FormLabel>ไม่มีความเสียหาย</FormLabel>
                            </Grid>
                            <Grid item xs={4} sm={4}></Grid>
                            </>
                        }
                    

                    <Grid item xs={12} sm={12}><h4>อุปกรณ์ตกแต่ง</h4></Grid>
                    {/*<Grid item xs={6} sm={3}>
                        <FormLabel >เครื่องเสียง</FormLabel>
                    </Grid>
                    <Grid item xs={6} sm={9}>
                        <FormLabel >
                            {
                                dataStep3?.imagesAudioEquipment && dataStep3.imagesAudioEquipment.length > 0 ?
                                "มี":"ไม่มี"
                            }
                        </FormLabel>
                    </Grid>*/}

                    <Grid item xs={6} sm={3}>
                        <FormLabel >ยางอะไหล่</FormLabel>
                    </Grid>
                    <Grid item xs={6} sm={9}>
                        <FormLabel >
                            {
                                dataStep3?.imagesSpareTire && dataStep3.imagesSpareTire.length > 0 ?
                                "มี":"ไม่มี"
                            }
                        </FormLabel>
                    </Grid>
                    
                    <Grid item xs={6} sm={3}>
                        <FormLabel >กล้องหน้ารถ</FormLabel>
                    </Grid>
                    <Grid item xs={6} sm={9}>
                        <FormLabel >
                            {
                                dataStep3?.imagesCarCAM && dataStep3.imagesCarCAM.length > 0 ?
                                "มี":"ไม่มี"
                            }
                        </FormLabel>
                    </Grid>
                    
                    <Grid item xs={6} sm={3}>
                        <FormLabel >ล้อแม็ก</FormLabel>
                    </Grid>
                    <Grid item xs={6} sm={9}>
                        <FormLabel >
                            {
                                dataStep3?.has_maxWheel == 1 ? "มี":"ไม่มี"
                            }
                        </FormLabel>
                    </Grid>
                    
                    {/*
                    <Grid item xs={6} sm={3}>
                        <FormLabel >(เพิ่มเติม)</FormLabel>
                    </Grid>
                    <Grid item xs={6} sm={9}>
                        <FormLabel >มี</FormLabel>
                    </Grid>
                    */}
                    

                    <Grid item xs={12} sm={12}><h4>เอกสาร</h4></Grid>
                    <Grid item xs={6} sm={3}>
                        <FormLabel >เล่มทะเบียนรถ</FormLabel>
                    </Grid>
                    <Grid item xs={6} sm={9}>
                        <FormLabel >
                            {
                                dataStep4?.imagesCarBook && dataStep4.imagesCarBook.length > 0 ?
                                "มี":"ไม่มี"
                            }
                        </FormLabel>
                    </Grid>

                    {/*<Grid item xs={6} sm={3}>
                        <FormLabel >ป้ายภาษีรถยนต์</FormLabel>
                    </Grid>
                    <Grid item xs={6} sm={9}>
                        <FormLabel >
                            {
                                dataStep4?.imagesCarTax && dataStep4.imagesCarTax.length > 0 ?
                                "มี":"ไม่มี"
                            }
                        </FormLabel>
                    </Grid>*/}
                    
                    <Grid item xs={6} sm={3}>
                        <FormLabel >เลขตัวถัง</FormLabel>
                    </Grid>
                    <Grid item xs={6} sm={9}>
                        <FormLabel >
                            {
                                dataStep4?.imagesCarChassis && dataStep4.imagesCarChassis.length > 0 ?
                                "มี":"ไม่มี"
                            }
                        </FormLabel>
                    </Grid>
                    
                    {/*<Grid item xs={6} sm={3}>
                        <FormLabel >ใบอนุญาตขับขี่/บัตรประชาชน</FormLabel>
                    </Grid>
                    <Grid item xs={6} sm={9}>
                        <FormLabel >
                            {
                                dataStep4?.imagesCarLicense && dataStep4.imagesCarLicense.length > 0 ?
                                "มี":"ไม่มี"
                            }
                        </FormLabel>
                    </Grid>*/}
                    
                    {/*
                    <Grid item xs={6} sm={3}>
                        <FormLabel >(เพิ่มเติม)</FormLabel>
                    </Grid>
                    <Grid item xs={6} sm={9}>
                        <FormLabel >มี</FormLabel>
                    </Grid>
                    */}
                    

                    <Grid item xs={12} sm={12}><h4>รายละเอียดเพิ่มเติม</h4></Grid>
                    <Grid item xs={12} sm={12}>
                        <FormLabel >- ความเสียหายเบื้องต้น ที่เกิดขึ้นก่อนการทำประกันภัย ซึ่งบริษัทฯ จะไม่รับผิดชอบการต่อความเสียหายดังกล่าว หากผู้เอาประกันจะต้องจัดซ่อมเสร็จสิ้น พร้อมทั้งนำรถมาตรวจสภาพใหม่อีกครั้ง ฉะนั้นหากมีอุบัติเหตุและมีความเสียหายเพิ่มเติมจากความเสียหายที่ตรวจพบแล้ว บริษัทฯ จะไม่รับผิดชอบค่าเสียหายในส่วนที่เกินจากที่ประเมินไว้เท่านั้น</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormLabel >- บันทีกการตรวจสภาพนี้ถือเป็นส่วนหนึ่งของสัญญารับประกันได้ตกลงจัดทำกับบริษัทฯ ซึ่งผู้เอาประกันได้อ่านและตกลงยอมรับตามเงื่อนไขข้างต้นแล้ว</FormLabel>
                    </Grid>{/*  จึงได้ลงลายมือชื่อ */}
                    <Grid item xs={12} sm={12}>
                        <FormLabel >- บริษัทฯ รวบรวมข้อมูลเพื่อใช้ในการทำประกันภัย โดยบริษัทจะไม่นำข้อมูลส่วนตัวของท่าน (อาทิเช่น ชื่อ-สกุล หมายเลขโทรศัพท์มือถือ เลขบัตรประชาชน) ไปเผยแพร่ในวัตถุประสงค์อื่นใด และท่านจะได้รับความคุ้มครองตาม พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562</FormLabel>
                    </Grid>
                    {/*<Grid item xs={12} sm={12}>
                        <Checkbox style={{paddingTop: '5px'}} onClick={()=> acceptionClick()} />
                        <FormLabel > ข้าพเจ้ายืนยันว่าข้าพเจ้าได้อ่านรายละเอียดเกี่ยวกับการเก็บรวบรวมใช้และเปิดเผยข้อมูลส่วนบุคคลเรียบร้อยแล้ว</FormLabel>
                    </Grid>*/}
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel 
                            control={
                                <Checkbox style={{paddingTop: '7px'}} 
                                onClick={()=> acceptionClick()} />
                            } 
                            
                            label={
                                <div style={{color: '#000000', opacity: '0.6'}} >
                                ข้าพเจ้ายืนยันว่าข้าพเจ้าได้อ่านรายละเอียดเกี่ยวกับการเก็บรวบรวมใช้และเปิดเผยข้อมูลส่วนบุคคลเรียบร้อยแล้ว
                                </div> 
                            }
                        />
                    </Grid>

                </Grid>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >

                    <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                        ย้อนกลับ
                    </Button>
                    <Button
                        variant="contained"
                        type="submit"
                        sx={{ mt: 3, ml: 1 }}
                        disabled={buttonSubmitDisable}
                    >
                        ยอมรับ
                    </Button>

                    {/*
                    <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                        ย้อนกลับ
                    </Button>

                    <LoadingButton
                        type="submit"
                        loading={isLoading}
                        loadingPosition="end"
                        endIcon={<EastIcon />}
                        variant="contained"
                        sx={{ mt: 3, ml: 1 }}
                    >
                        สมัคร
                    </LoadingButton> 
                    */}
                    
                </Box>
            </form>
        </React.Fragment>
    );
}
